/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable import/prefer-default-export */
import useTranslate from '../hooks/useTranslate/useTranslate';

export function getAltText(imageObject, defaultAlt = "") {
  // If alt is for operator image we check for custom translations
  if(imageObject && imageObject.alt && imageObject.alt.toLowerCase().includes('image for')) {
    const originalAlt = imageObject.alt.toLowerCase();
    const regex = /(logo image for|image for)\s*/i;

    // Replace all occurrences of the matched phrases with an empty string
    const newAlt = `${useTranslate('image_for', 'Logo image for')} ${originalAlt.replace(regex, '')}`;
    return useTranslate(newAlt.replace(/\s+/g, '_').toLowerCase(), newAlt);
  }
  
  return imageObject && imageObject.alt ? imageObject.alt : defaultAlt;
}

export function getImageFilename(src) {
  const srcArr = src && src.substring(src.lastIndexOf("/") + 1).split(".");
  if (!srcArr.length) {
    return "";
  }

  return srcArr[0];
}
